import { z } from 'zod/v4';

export const churnDataSchema = z.object({
  churn: z.number(),
  churnPeriod: z.string(),
  dateGroupingType: z.number(),
});

export type ChurnData = z.infer<typeof churnDataSchema>;
